/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Database } from './Database';
import {
    DatabaseFromJSON,
    DatabaseFromJSONTyped,
    DatabaseToJSON,
} from './Database';
import type { DatabaseAppearanceProperties } from './DatabaseAppearanceProperties';
import {
    DatabaseAppearancePropertiesFromJSON,
    DatabaseAppearancePropertiesFromJSONTyped,
    DatabaseAppearancePropertiesToJSON,
} from './DatabaseAppearanceProperties';
import type { DatabaseArt } from './DatabaseArt';
import {
    DatabaseArtFromJSON,
    DatabaseArtFromJSONTyped,
    DatabaseArtToJSON,
} from './DatabaseArt';
import type { DatabaseAudioSettings } from './DatabaseAudioSettings';
import {
    DatabaseAudioSettingsFromJSON,
    DatabaseAudioSettingsFromJSONTyped,
    DatabaseAudioSettingsToJSON,
} from './DatabaseAudioSettings';
import type { DatabaseBackgroundImageSettings } from './DatabaseBackgroundImageSettings';
import {
    DatabaseBackgroundImageSettingsFromJSON,
    DatabaseBackgroundImageSettingsFromJSONTyped,
    DatabaseBackgroundImageSettingsToJSON,
} from './DatabaseBackgroundImageSettings';
import type { DatabaseEntryFileMetaData } from './DatabaseEntryFileMetaData';
import {
    DatabaseEntryFileMetaDataFromJSON,
    DatabaseEntryFileMetaDataFromJSONTyped,
    DatabaseEntryFileMetaDataToJSON,
} from './DatabaseEntryFileMetaData';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFlyerToolbarSettings } from './DatabaseFlyerToolbarSettings';
import {
    DatabaseFlyerToolbarSettingsFromJSON,
    DatabaseFlyerToolbarSettingsFromJSONTyped,
    DatabaseFlyerToolbarSettingsToJSON,
} from './DatabaseFlyerToolbarSettings';
import type { DatabaseMediaStartMode } from './DatabaseMediaStartMode';
import {
    DatabaseMediaStartModeFromJSON,
    DatabaseMediaStartModeFromJSONTyped,
    DatabaseMediaStartModeToJSON,
} from './DatabaseMediaStartMode';
import type { DatabasePageTransitionName } from './DatabasePageTransitionName';
import {
    DatabasePageTransitionNameFromJSON,
    DatabasePageTransitionNameFromJSONTyped,
    DatabasePageTransitionNameToJSON,
} from './DatabasePageTransitionName';
import type { DatabasePages } from './DatabasePages';
import {
    DatabasePagesFromJSON,
    DatabasePagesFromJSONTyped,
    DatabasePagesToJSON,
} from './DatabasePages';
import type { DatabaseSettings } from './DatabaseSettings';
import {
    DatabaseSettingsFromJSON,
    DatabaseSettingsFromJSONTyped,
    DatabaseSettingsToJSON,
} from './DatabaseSettings';
import type { DatabaseUser } from './DatabaseUser';
import {
    DatabaseUserFromJSON,
    DatabaseUserFromJSONTyped,
    DatabaseUserToJSON,
} from './DatabaseUser';

/**
 * 
 * @export
 * @interface Database
 */
export interface Database {
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    subUri?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    detailsHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    imprint?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    imprintEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    readonly considerCustomerFinePrints?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    locked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    adminLocked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Database
     */
    entriesSize?: number;
    /**
     * Anzahl der Datensätze in dieser Datenbank
     * @type {number}
     * @memberof Database
     */
    entriesCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    readonly templateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    readonly allowStaticContentModification?: boolean;
    /**
     * 
     * @type {Array<Database>}
     * @memberof Database
     */
    readonly children?: Array<Database>;
    /**
     * 
     * @type {DatabaseUser}
     * @memberof Database
     */
    owner?: DatabaseUser;
    /**
     * Synchronisations-Modus (manuell oder automatisch)
     * @type {string}
     * @memberof Database
     */
    syncMode?: DatabaseSyncModeEnum;
    /**
     * Verhalten bei geaenderten Quell-Datensaetzen beim Datenabruf
     * @type {string}
     * @memberof Database
     */
    syncUpdateMode?: DatabaseSyncUpdateModeEnum;
    /**
     * Ob beim automatischen Datenabruf / manuellen "Aktualisieren" NEUE Quell-Datensaetze automatisch uebernommen werden. true/null = ja (bisheriges Verhalten); false = nur bereits abgerufene aktualisieren (keine neuen anlegen). Die manuelle Einzelauswahl bleibt unberuehrt.
     * @type {boolean}
     * @memberof Database
     */
    syncPullNewEntries?: boolean;
    /**
     * Welche Ausgaben beim Datenabruf geliefert werden. ALL/null = alle (bisheriges Verhalten); WITH_ARTICLES = nur Ausgaben, zu denen ein abgerufener Artikel im selben Datums-Bucket gehoert; WITH_ARTICLES_AND_FUTURE = zusaetzlich alle Ausgaben mit editionDate in der Zukunft.
     * @type {string}
     * @memberof Database
     */
    syncEditionMode?: DatabaseSyncEditionModeEnum;
    /**
     * Zeitpunkt der letzten Synchronisation
     * @type {Date}
     * @memberof Database
     */
    readonly lastSync?: Date;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof Database
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Database
     */
    readonly updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    hasCommentBtn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    hasLikeBtn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    hideFieldTitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    hideDetailsForAnonymous?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    sendMailOnNewEntry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    sendMailOnNewComment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    ownSmtpSettings?: boolean;
    /**
     * Multi-Import für Bilder zulassen (Sub-DB)
     * @type {boolean}
     * @memberof Database
     */
    allowMultiImageImport?: boolean;
    /**
     * Multi-Import für Dateien zulassen (Sub-DB)
     * @type {boolean}
     * @memberof Database
     */
    allowMultiFileImport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Database
     */
    readonly hasChildren?: boolean;
    /**
     * 
     * @type {Array<DatabaseField>}
     * @memberof Database
     */
    readonly fields?: Array<DatabaseField>;
    /**
     * 
     * @type {Array<DatabaseEntryFileMetaData>}
     * @memberof Database
     */
    readonly attachments?: Array<DatabaseEntryFileMetaData>;
    /**
     * 
     * @type {DatabaseAppearanceProperties}
     * @memberof Database
     */
    appearance?: DatabaseAppearanceProperties;
    /**
     * 
     * @type {DatabaseSettings}
     * @memberof Database
     */
    settings?: DatabaseSettings;
    /**
     * 
     * @type {DatabasePages}
     * @memberof Database
     */
    additionalPages?: DatabasePages;
    /**
     * 
     * @type {Array<string>}
     * @memberof Database
     */
    readonly contentPages?: Array<string>;
    /**
     * 
     * @type {DatabasePageTransitionName}
     * @memberof Database
     */
    pageTransition?: DatabasePageTransitionName;
    /**
     * 
     * @type {DatabaseMediaStartMode}
     * @memberof Database
     */
    mediaStartMode?: DatabaseMediaStartMode;
    /**
     * 
     * @type {DatabaseAudioSettings}
     * @memberof Database
     */
    audio?: DatabaseAudioSettings;
    /**
     * 
     * @type {DatabaseBackgroundImageSettings}
     * @memberof Database
     */
    backgroundImage?: DatabaseBackgroundImageSettings;
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    imageRef?: string;
    /**
     * 
     * @type {DatabaseFlyerToolbarSettings}
     * @memberof Database
     */
    flyerToolbar?: DatabaseFlyerToolbarSettings;
    /**
     * Datenabruf/Content-Syndication aktiviert
     * @type {boolean}
     * @memberof Database
     */
    syncEnabled?: boolean;
    /**
     * ID der Quell-Datenbank für Datenabruf
     * @type {string}
     * @memberof Database
     */
    sourceDbId?: string;
    /**
     * 
     * @type {DatabaseArt}
     * @memberof Database
     */
    art?: DatabaseArt;
}


/**
 * @export
 */
export const DatabaseSyncModeEnum = {
    Manual: 'MANUAL',
    Automatic: 'AUTOMATIC'
} as const;
export type DatabaseSyncModeEnum = typeof DatabaseSyncModeEnum[keyof typeof DatabaseSyncModeEnum];

/**
 * @export
 */
export const DatabaseSyncUpdateModeEnum = {
    NoUpdate: 'NO_UPDATE',
    KeepIfLocallyChanged: 'KEEP_IF_LOCALLY_CHANGED',
    AddAsNew: 'ADD_AS_NEW',
    Overwrite: 'OVERWRITE'
} as const;
export type DatabaseSyncUpdateModeEnum = typeof DatabaseSyncUpdateModeEnum[keyof typeof DatabaseSyncUpdateModeEnum];

/**
 * @export
 */
export const DatabaseSyncEditionModeEnum = {
    All: 'ALL',
    WithArticles: 'WITH_ARTICLES',
    WithArticlesAndFuture: 'WITH_ARTICLES_AND_FUTURE'
} as const;
export type DatabaseSyncEditionModeEnum = typeof DatabaseSyncEditionModeEnum[keyof typeof DatabaseSyncEditionModeEnum];


/**
 * Check if a given object implements the Database interface.
 */
export function instanceOfDatabase(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFromJSON(json: any): Database {
    return DatabaseFromJSONTyped(json, false);
}

export function DatabaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Database {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subUri': !exists(json, 'subUri') ? undefined : json['subUri'],
        'detailsHeader': !exists(json, 'detailsHeader') ? undefined : json['detailsHeader'],
        'imprint': !exists(json, 'imprint') ? undefined : json['imprint'],
        'imprintEnabled': !exists(json, 'imprintEnabled') ? undefined : json['imprintEnabled'],
        'considerCustomerFinePrints': !exists(json, 'considerCustomerFinePrints') ? undefined : json['considerCustomerFinePrints'],
        'locked': !exists(json, 'locked') ? undefined : json['locked'],
        'adminLocked': !exists(json, 'adminLocked') ? undefined : json['adminLocked'],
        'entriesSize': !exists(json, 'entriesSize') ? undefined : json['entriesSize'],
        'entriesCount': !exists(json, 'entriesCount') ? undefined : json['entriesCount'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'templateId': !exists(json, 'templateId') ? undefined : json['templateId'],
        'allowStaticContentModification': !exists(json, 'allowStaticContentModification') ? undefined : json['allowStaticContentModification'],
        'children': !exists(json, 'children') ? undefined : ((json['children'] as Array<any>).map(DatabaseFromJSON)),
        'owner': !exists(json, 'owner') ? undefined : DatabaseUserFromJSON(json['owner']),
        'syncMode': !exists(json, 'syncMode') ? undefined : json['syncMode'],
        'syncUpdateMode': !exists(json, 'syncUpdateMode') ? undefined : json['syncUpdateMode'],
        'syncPullNewEntries': !exists(json, 'syncPullNewEntries') ? undefined : json['syncPullNewEntries'],
        'syncEditionMode': !exists(json, 'syncEditionMode') ? undefined : json['syncEditionMode'],
        'lastSync': !exists(json, 'lastSync') ? undefined : (new Date(json['lastSync'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'hasCommentBtn': !exists(json, 'hasCommentBtn') ? undefined : json['hasCommentBtn'],
        'hasLikeBtn': !exists(json, 'hasLikeBtn') ? undefined : json['hasLikeBtn'],
        'hideFieldTitles': !exists(json, 'hideFieldTitles') ? undefined : json['hideFieldTitles'],
        'hideDetailsForAnonymous': !exists(json, 'hideDetailsForAnonymous') ? undefined : json['hideDetailsForAnonymous'],
        'sendMailOnNewEntry': !exists(json, 'sendMailOnNewEntry') ? undefined : json['sendMailOnNewEntry'],
        'sendMailOnNewComment': !exists(json, 'sendMailOnNewComment') ? undefined : json['sendMailOnNewComment'],
        'ownSmtpSettings': !exists(json, 'ownSmtpSettings') ? undefined : json['ownSmtpSettings'],
        'allowMultiImageImport': !exists(json, 'allowMultiImageImport') ? undefined : json['allowMultiImageImport'],
        'allowMultiFileImport': !exists(json, 'allowMultiFileImport') ? undefined : json['allowMultiFileImport'],
        'hasChildren': !exists(json, 'hasChildren') ? undefined : json['hasChildren'],
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(DatabaseFieldFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(DatabaseEntryFileMetaDataFromJSON)),
        'appearance': !exists(json, 'appearance') ? undefined : DatabaseAppearancePropertiesFromJSON(json['appearance']),
        'settings': !exists(json, 'settings') ? undefined : DatabaseSettingsFromJSON(json['settings']),
        'additionalPages': !exists(json, 'additionalPages') ? undefined : DatabasePagesFromJSON(json['additionalPages']),
        'contentPages': !exists(json, 'contentPages') ? undefined : json['contentPages'],
        'pageTransition': !exists(json, 'pageTransition') ? undefined : DatabasePageTransitionNameFromJSON(json['pageTransition']),
        'mediaStartMode': !exists(json, 'mediaStartMode') ? undefined : DatabaseMediaStartModeFromJSON(json['mediaStartMode']),
        'audio': !exists(json, 'audio') ? undefined : DatabaseAudioSettingsFromJSON(json['audio']),
        'backgroundImage': !exists(json, 'backgroundImage') ? undefined : DatabaseBackgroundImageSettingsFromJSON(json['backgroundImage']),
        'imageRef': !exists(json, 'imageRef') ? undefined : json['imageRef'],
        'flyerToolbar': !exists(json, 'flyerToolbar') ? undefined : DatabaseFlyerToolbarSettingsFromJSON(json['flyerToolbar']),
        'syncEnabled': !exists(json, 'syncEnabled') ? undefined : json['syncEnabled'],
        'sourceDbId': !exists(json, 'sourceDbId') ? undefined : json['sourceDbId'],
        'art': !exists(json, 'art') ? undefined : DatabaseArtFromJSON(json['art']),
    };
}

export function DatabaseToJSON(value?: Database | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subUri': value.subUri,
        'detailsHeader': value.detailsHeader,
        'imprint': value.imprint,
        'imprintEnabled': value.imprintEnabled,
        'locked': value.locked,
        'adminLocked': value.adminLocked,
        'entriesSize': value.entriesSize,
        'entriesCount': value.entriesCount,
        'parent': value.parent,
        'owner': DatabaseUserToJSON(value.owner),
        'syncMode': value.syncMode,
        'syncUpdateMode': value.syncUpdateMode,
        'syncPullNewEntries': value.syncPullNewEntries,
        'syncEditionMode': value.syncEditionMode,
        'name': value.name,
        'title': value.title,
        'description': value.description,
        'hasCommentBtn': value.hasCommentBtn,
        'hasLikeBtn': value.hasLikeBtn,
        'hideFieldTitles': value.hideFieldTitles,
        'hideDetailsForAnonymous': value.hideDetailsForAnonymous,
        'sendMailOnNewEntry': value.sendMailOnNewEntry,
        'sendMailOnNewComment': value.sendMailOnNewComment,
        'ownSmtpSettings': value.ownSmtpSettings,
        'allowMultiImageImport': value.allowMultiImageImport,
        'allowMultiFileImport': value.allowMultiFileImport,
        'appearance': DatabaseAppearancePropertiesToJSON(value.appearance),
        'settings': DatabaseSettingsToJSON(value.settings),
        'additionalPages': DatabasePagesToJSON(value.additionalPages),
        'pageTransition': DatabasePageTransitionNameToJSON(value.pageTransition),
        'mediaStartMode': DatabaseMediaStartModeToJSON(value.mediaStartMode),
        'audio': DatabaseAudioSettingsToJSON(value.audio),
        'backgroundImage': DatabaseBackgroundImageSettingsToJSON(value.backgroundImage),
        'imageRef': value.imageRef,
        'flyerToolbar': DatabaseFlyerToolbarSettingsToJSON(value.flyerToolbar),
        'syncEnabled': value.syncEnabled,
        'sourceDbId': value.sourceDbId,
        'art': DatabaseArtToJSON(value.art),
    };
}

